import React from 'react';

const Notfound = () => {
   return (
      <div>
         <h1>Sorry page not found</h1>
      </div>
   );
};

export default Notfound;